import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RoleType } from '../models';
import { SharedSessionService } from '../services/shared-session.service';

@Directive({
  selector: '[hasRight]', // eslint-disable-line @angular-eslint/directive-selector
})
export class HasRightDirective {
  hasView = false;

  constructor(
    private apiService: SharedSessionService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input() set hasRight(role: RoleType) {
    if (!role) {
      this.setElement(true);
      return;
    }
    this.setElement(this.apiService.userRole === role);
  }

  private setElement(isShown: boolean) {
    if (isShown && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isShown && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
